import React, { useState } from 'react';
import { Tabs, Input, Button, message } from 'antd';
import dayjs from 'dayjs';
import api from '../../services/api';
import { DataTable } from '../PageLayout';
import { buildChangeLogRows } from './approvalProgressUtils';

export default function ProcessOtherSection({
  bizType,
  bizId,
  process,
  comments: initialComments = [],
  onCommentsChange,
  commentApi = 'hr'
}) {
  const [commentText, setCommentText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [comments, setComments] = useState(initialComments);

  React.useEffect(() => {
    setComments(initialComments);
  }, [initialComments]);

  const handleSubmitComment = async () => {
    const text = commentText.trim();
    if (!text) {
      message.warning('请输入评论内容');
      return;
    }
    if (!bizId) {
      message.warning('请先提交流程后再评论');
      return;
    }
    try {
      setSubmitting(true);
      const url = commentApi === 'approval-center'
        ? '/approval-center/comments'
        : `/hr/processes/${bizId}/comments`;
      const payload = commentApi === 'approval-center'
        ? { biz_type: bizType, biz_id: bizId, content: text }
        : { content: text };
      const res = await api.post(url, payload);
      if (res.data.success) {
        const next = [...comments, res.data.data];
        setComments(next);
        setCommentText('');
        onCommentsChange?.(next);
        message.success('评论已发布');
      }
    } catch (e) {
      message.error(e.response?.data?.message || '评论失败');
    } finally {
      setSubmitting(false);
    }
  };

  const changeRows = buildChangeLogRows(process || {});
  const hasCommentText = Boolean(commentText.trim());

  const tabItems = [
    {
      key: 'comment',
      label: '评论',
      children: (
        <div className="process-other-panel">
          {comments.length > 0 && (
            <div className="process-comment-list">
              {comments.map((c) => (
                <div key={c.id} className="process-comment-item">
                  <div className="process-comment-head">
                    <strong>{c.user_name || '用户'}</strong>
                    <span>{dayjs(c.create_time).format('YYYY-MM-DD HH:mm')}</span>
                  </div>
                  <div className="process-comment-body">{c.content}</div>
                </div>
              ))}
            </div>
          )}
          <Input.TextArea
            placeholder="请输入评论"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            rows={3}
            maxLength={1000}
            disabled={!bizId}
          />
          {hasCommentText && (
            <Button
              type="primary"
              style={{ marginTop: 12 }}
              loading={submitting}
              disabled={!bizId}
              onClick={handleSubmitComment}
            >
              发布评论
            </Button>
          )}
        </div>
      )
    },
    {
      key: 'history',
      label: '变更记录',
      children: (
        <div className="process-other-panel">
          <DataTable
            size="small"
            rowKey="key"
            dataSource={changeRows}
            columns={[
              {
                title: '时间',
                dataIndex: 'time',
                width: 160,
                render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm')
              },
              { title: '操作人', dataIndex: 'user', width: 100 },
              { title: '操作', dataIndex: 'action', width: 80 },
              { title: '意见', dataIndex: 'comment', ellipsis: true }
            ]}
          />
        </div>
      )
    }
  ];

  return (
    <div className="process-other">
      <Tabs items={tabItems} />
    </div>
  );
}
